export default function PlayerSVG({
  team,
  stance = "regular",
  angle = 0,
  ...props
}) {
  return (
    <svg
      style={props.style}
      id={props.id ?? ""}
      className={"draggable " + (props.className ?? "")}
      x={props.x - props.width * 1.5}
      y={props.y - props.width * 1.5}
      width={props.width * 3}
      height={props.width * 3}
      viewBox="-150 -150 300 300"
    >
      <g className="rotation_wrapper" transform={"rotate(" + angle + " 0 0)"}>
        {team === "ball" && !props.animatable && (
          <circle
            cx={0}
            cy={0}
            r={46.5}
            fill={"transparent"}
            stroke={props.color}
            strokeWidth={7}
            shapeRendering="geometricPrecision"
          />
        )}

        {["ball", "offense"].includes(team) && !props.edit && (
          <text
            textAnchor="middle"
            dominantBaseline="central"
            fill={props.color}
            fontWeight="700"
            fontSize={props.number.toString().length <= 1 ? 70 : 50}
            x={0}
            y={0}
          >
            {props.number === "" && team === "offense" ? "?" : props.number}
          </text>
        )}

        {team === "defense_alt" && !props.edit && (
          <>
            <g>
              {stance === "regular" && (
                <>
                  <path
                    className="stance_path"
                    fill="none"
                    stroke={props.color}
                    strokeWidth={9}
                    d="M -110 20 Q -80 -10 -40 0"
                  />

                  <path
                    className="stance_path"
                    fill="none"
                    stroke={props.color}
                    strokeWidth={9}
                    d="M 110 20 Q 80 -10 40 0"
                  />
                </>
              )}

              {stance === "box_out_right" && (
                <>
                  <path
                    className="stance_path"
                    fill="none"
                    stroke={props.color}
                    strokeWidth={9}
                    d="M -40 0 Q -60 0 -60 35 Q -60 70 -30 70 L 40 70 "
                  />
                </>
              )}

              {stance === "box_out_left" && (
                <>
                  <path
                    className="stance_path"
                    fill="none"
                    stroke={props.color}
                    strokeWidth={9}
                    d="M 40 0 Q 60 0 60 35 Q 60 70 30 70 L -50 70 "
                  />
                </>
              )}

              {stance === "off_ball" && (
                <>
                  <path
                    className="stance_path"
                    fill="none"
                    stroke={props.color}
                    strokeWidth={9}
                    d="M -70 15 Q -60 -10 -40 0"
                  />

                  <path
                    className="stance_path"
                    fill="none"
                    stroke={props.color}
                    strokeWidth={9}
                    d="M 70 15 Q 60 -10 40 0"
                  />
                </>
              )}

              {stance === "deny_right" && (
                <>
                  <path
                    className="stance_path"
                    fill="none"
                    stroke={props.color}
                    strokeWidth={9}
                    d="M -110 20 Q -80 -10 -40 0"
                  />
                  <path
                    className="stance_path"
                    fill="none"
                    stroke={props.color}
                    strokeWidth={9}
                    d="M 60 25 Q 65 0 40 0"
                  />
                </>
              )}

              {stance === "deny_left" && (
                <>
                  <path
                    className="stance_path"
                    fill="none"
                    stroke={props.color}
                    strokeWidth={9}
                    d="M 110 10 Q 80 -20 40 0"
                  />
                  <path
                    className="stance_path"
                    fill="none"
                    stroke={props.color}
                    strokeWidth={9}
                    d="M -60 25 Q -65 0 -40 0"
                  />
                </>
              )}
            </g>

            {/*
          <path
            fill="none"
            stroke={props.color}
            strokeWidth={9}
            d="M 130 -25 Q 87.75 10 46.5 0"
      /> */}

            <circle
              cx={0}
              cy={0}
              r={35}
              fill={props.color}
              stroke={props.color}
              strokeWidth={7}
              shapeRendering="geometricPrecision"
            />
            <g className="rotate_text" transform={"rotate(" + -angle + " 0 0)"}>
              <text
                textAnchor="middle"
                dominantBaseline="central"
                fill={"#eee"}
                fontWeight="700"
                fontSize={props.number.toString().length <= 1 ? 50 : 40}
                x={0}
                y={0}
              >
                {props.number === "" && team === "offense" ? "?" : props.number}
              </text>
            </g>
          </>
        )}

        {team === "defense" && !props.edit && (
          <>
            <path stroke={props.color} strokeWidth={9} d="M -30 -24 10 24" />
            <path stroke={props.color} strokeWidth={9} d="M 10 -24 -30 24" />
            <text
              textAnchor="middle"
              dominantBaseline="central"
              fill={props.color}
              fontWeight="700"
              fontSize={props.number.toString().length <= 1 ? 45 : 30}
              x={30}
              y={20}
            >
              {props.number}
            </text>
          </>
        )}

        {props.edit && (
          <foreignObject width="100" height="100" x={-50} y={-50}>
            <form
              onSubmit={() => {
                props.endInput();
              }}
            >
              <input
                onClick={(event) => {
                  event.stopPropagation();
                  event.nativeEvent.stopPropagation();
                  event.nativeEvent.stopImmediatePropagation();
                }}
                onChange={(event) => {
                  event.stopPropagation();
                  event.nativeEvent.stopPropagation();
                  event.nativeEvent.stopImmediatePropagation();
                  props.changingNumber(event.target.value);
                }}
                maxLength={2}
                autoFocus
                style={{
                  fontwidth: 100,
                  height: 100,
                  fontWeight: 700,
                  border: "none",
                  backgroundColor: "#fff",
                  fontSize: props.number.toString().length <= 1 ? 70 : 50,
                  padding: 10,
                  textAlign: "center",
                  width: "100%",
                }}
                id="label_input"
                type="text"
                defaultValue={props.number}
              />
            </form>
          </foreignObject>
        )}
      </g>
    </svg>
  );
}
